import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { BaseError } from '../../helpers/BaseError';

import {
    SingleTestMessageSettingModel,
    SingleTestMessageSettingUpdate,
} from './../../models/contact_notification_token';

import API from '../../services/api';
import { toastService } from '../../services/toast.service';

import testMessageSettingUserKeys from './_querykeys';

export default function useSingleTestMessageUpdate(tokenUserId: string) {
    const queryClient = useQueryClient();
    return useMutation<
        AxiosResponse<SingleTestMessageSettingModel>,
        BaseError,
        SingleTestMessageSettingUpdate
    >({
        mutationFn: (data: SingleTestMessageSettingUpdate) =>
            API.updateSingleTestMessageSettingUser(tokenUserId, data),

        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey:
                    testMessageSettingUserKeys.filteredSingleTestMessageUser(
                        undefined,
                    ),
            });
            toastService.showSuccess('Successfully updated.');
        },
    });
}
